import { TAGS_HIERARCHY_PATH } from 'apps/navigation/constants';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

export default [
  {
    path: `regulars${TAGS_HIERARCHY_PATH}`,
    getComponent(location, callback) {
      import(/* webpackChunkName: "subscriptions" */ './containers/SubscriptionsPage')
        .then(component => callback(null, component.default));
    },
    layoutSidebarLeft: true,
    gtmPageType: gtmPageTypes.Subscriptions,
  },
];
